import { createStackNavigator } from '@react-navigation/stack';
import React from 'react';
import { batchDetailsToolConfig } from './config';
import { NAVIGATION_CONFIG } from '@v2/pages/common/constants/base.constants';

const BatchDetailsToolStack = createStackNavigator();

const BatchDetailsToolNavigator = () => {
  return (
    <BatchDetailsToolStack.Navigator screenOptions={NAVIGATION_CONFIG}>
      {batchDetailsToolConfig.map(({ Component, name }) => (
        <BatchDetailsToolStack.Screen key={name} name={name} component={Component} />
      ))}
    </BatchDetailsToolStack.Navigator>
  );
};

export { BatchDetailsToolNavigator };
